import { Autocomplete as MUIAutocomplete, styled } from '@mui/material'

export const Autocomplete = styled(MUIAutocomplete)(({ theme }) => ({
  '& input': {
    height: theme.spacing(3),
  },
}))
